
import './App.css';
import Page from './containers/Page';

function App() {
  return (
    <div className="App">
   <Page></Page>
    </div>
  );
}

export default App;
